module.exports = __webpack_public_path__ + "static/media/Link-Order.dd767df2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/pos/Link-Order.png
// module id = 103
// module chunks = 0